import React from 'react';
import classNames from 'classnames';

import './WpProgressBar.scss';

type Color = 'info' | 'success' | 'warning' | 'danger' | 'fun' | 'boring' | 'primary' | 'purple';
const DEFAULT_COLOR = 'info';

export type Size = 'sm' | 'md';
const DEFAULT_SIZE = 'sm';

export interface Props {
  /** fill color of the bar:
   * Options: 'info' | 'success' | 'warning' | 'danger' | 'fun' | 'boring' | 'primary' | 'purple
   * @default 'info'
   */
  color?: Color;
  /**
   * Size of the bar. Options: 'sm' | 'md'
   * @default 'md'
   */
  size?: Size;
  percent: number;
}

const WpProgressBar: React.FC<Props> = ({ color = DEFAULT_COLOR, size = DEFAULT_SIZE, percent }: Props) => {
  const classNamePrefix = 'WpProgressBar';
  const classes = classNames(classNamePrefix, `${classNamePrefix}--${color}`, `${classNamePrefix}--${size}`);

  return (
    <div className={classes}>
      <div
        className={`${classNamePrefix}__bar`}
        style={{
          width: `${percent}%`,
        }}
        role="progressbar"
      />
    </div>
  );
};

export default WpProgressBar;
